import { isMockApiFlag } from "../apiMode";
import { apiService, API_ENDPOINTS } from "../api";
import { MOCK_WORKSPACES } from "./workspacesMock";
import type {
  WorkspaceApi,
} from "./workspaces.types";

const isMockWorkspaceDetailApi = (): boolean =>
  isMockApiFlag(process.env.REACT_APP_WORKSPACE_DETAIL_API);

const fetchWorkspaceDetailMock = async (workspaceId: string): Promise<WorkspaceApi> => {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const workspace = MOCK_WORKSPACES.find((w) => w.id === workspaceId);

  // Return default workspace for unknown IDs (allows testing with real workspace UUIDs)
  const workspaceToUse = workspace || {
    id: workspaceId,
    tenantId: "mock-tenant-uuid-001",
    name: "Default Workspace",
    description: "Default workspace for testing",
    isActive: true,
    createdAt: "2026-06-15T05:18:40.727229Z",
    updatedAt: "2026-06-15T05:18:40.727229Z",
    owner: {
      id: "mock-user-uuid-001",
      name: "Mock User",
      email: "mock@example.com",
    },
    members: [
      { id: "u-mock-1", name: "Alice Chen", avatarUrl: null },
    ],
    membersTotal: 1,
    dataSourceCount: 1,
    dataStoryCount: 0,
    currentUserRole: "owner",
  };

  return {
    id: workspaceToUse.id,
    tenant_id: workspaceToUse.tenantId,
    name: workspaceToUse.name,
    description: workspaceToUse.description,
    is_active: workspaceToUse.isActive,
    created_at: workspaceToUse.createdAt,
    updated_at: workspaceToUse.updatedAt,
    owner: workspaceToUse.owner
      ? { id: workspaceToUse.owner.id, name: workspaceToUse.owner.name, email: workspaceToUse.owner.email }
      : null,
    members: workspaceToUse.members.map((m) => ({
      id: m.id,
      name: m.name,
      avatar_url: m.avatarUrl,
    })),
    members_total: workspaceToUse.membersTotal,
    data_source_count: workspaceToUse.dataSourceCount,
    data_story_count: workspaceToUse.dataStoryCount,
    current_user_role: workspaceToUse.currentUserRole,
  };
};

export const fetchWorkspaceDetail = async (workspaceId: string): Promise<WorkspaceApi> => {
  if (isMockWorkspaceDetailApi()) {
    return fetchWorkspaceDetailMock(workspaceId);
  }
  return apiService.get<WorkspaceApi>(API_ENDPOINTS.workspaces.detail(workspaceId));
};
